import React, { createContext, useContext, useState } from 'react';

export const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(''); // 'success' or 'error'

  const showLoading = () => setIsLoading(true);
  const hideLoading = (msg = '', status = '') => {
    setIsLoading(false);
    setMessage(msg);
    setStatus(status);

    if (msg) {
      setTimeout(() => {
        setMessage('');
        setStatus('');
      }, 5000); // Hide the message after 3 seconds
    }
  };

  return (
    <LoadingContext.Provider
      value={{ isLoading, showLoading, hideLoading, message, status }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
